export default "__VITE_ASSET__CfTGyYLN__"